<template>
<div class="main-app link-pay">
   <!-- <span class="guide" @click.prevent.stop="guide"> <span class="  mdi mdi-television-guide"></span>
   </span> -->
   <v-app>
     <router-view />
   </v-app>
    
</div>
</template>

<script>
import Driver from 'driver.js' // import driver.js
import 'driver.js/dist/driver.min.css' // import driver.js css
import steps from './guid/step'


  export default {
    name: 'App',
   
    data () {
      return {
        driver: null,
        isChecked: false
      }
    },
    mounted () {
      this.driver = new Driver();
    },
    methods: {
      guide() {
        this.driver.defineSteps(steps)
        this.driver.start()
      },
    }
  }
</script>
<style>
@import "./fonts/font.css";
</style>
